import * as React from "react";

const sizeStyles = {
  sm: { width: '2rem', height: '2rem', fontSize: '0.75rem' },
  md: { width: '2.5rem', height: '2.5rem', fontSize: '0.875rem' },
  lg: { width: '3rem', height: '3rem', fontSize: '1rem' },
  xl: { width: '4rem', height: '4rem', fontSize: '1.125rem' },
};

const Avatar = React.forwardRef(({ className, src, alt, fallback, size = "md", style, ...props }, ref) => {
  const [imageError, setImageError] = React.useState(false);

  const getInitials = (name) => {
    if (!name) return "?";
    const parts = name.split(" ");
    if (parts.length >= 2) {
      return (parts[0][0] + parts[1][0]).toUpperCase();
    }
    return name.slice(0, 2).toUpperCase();
  };

  const avatarStyle = {
    position: 'relative',
    display: 'flex',
    flexShrink: 0,
    overflow: 'hidden',
    borderRadius: '50%',
    backgroundColor: '#ffffff',
    boxShadow: '0 0 0 2px white, 0 1px 2px 0 rgba(0, 0, 0, 0.05)',
    ...(sizeStyles[size] || sizeStyles.md),
    ...style,
  };

  return (
    <div
      ref={ref}
      style={avatarStyle}
      {...props}
    >
      {src && !imageError ? (
        <img
          src={src}
          alt={alt || "Avatar"}
          style={{
            aspectRatio: '1 / 1',
            height: '100%',
            width: '100%',
            objectFit: 'cover',
          }}
          onError={() => setImageError(true)}
        />
      ) : (
        <span style={{
          display: 'flex',
          height: '100%',
          width: '100%',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: 600,
          color: '#374151',
          backgroundColor: '#e5e7eb',
          borderRadius: '50%',
        }}>
          {getInitials(fallback || alt)}
        </span>
      )}
    </div>
  );
});
Avatar.displayName = "Avatar";

export { Avatar };
